import type { AdminDashboardStats, AdminOrderRecord, DealerOrderCreateInput } from '@/lib/domain';
import type { DealerOrder } from '@/mocks/dealerOrders';
import { apiGet, apiSend } from '@/lib/api/client';

export async function fetchDealerOrders(): Promise<DealerOrder[]> {
  return apiGet<DealerOrder[]>('/dealer/orders.php');
}

export async function createDealerOrder(input: DealerOrderCreateInput) {
  return apiSend<DealerOrder>('/dealer/orders.php', 'POST', input);
}

export async function fetchAdminOrders(): Promise<AdminOrderRecord[]> {
  return apiGet<AdminOrderRecord[]>('/admin/orders.php');
}

export async function updateOrderStatus(orderId: string, status: DealerOrder['status']) {
  return apiSend<null>('/admin/orders.php', 'PATCH', { orderId, status });
}

export async function fetchAdminDashboardStats(): Promise<AdminDashboardStats> {
  return apiGet<AdminDashboardStats>('/admin/dashboard.php');
}
